import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import DogsGrid from './components/DogsGrid';
import Stories from './components/Stories';
import AdoptionSteps from './components/AdoptionSteps';
import Donations from './components/Donations';
import Testimonials from './components/Testimonials';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import DogStoryPage from './pages/DogStoryPage';
import VolunteerPage from './pages/VolunteerPage';
import ContactPage from './pages/ContactPage';
import AdoptionPage from './pages/AdoptionPage';
import AddDogPage from './pages/AddDogPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

function App() {
  const [currentHash, setCurrentHash] = useState(window.location.hash);

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentHash(window.location.hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const renderContent = () => {
    // Simple routing logic based on hash
    if (currentHash === '#/volontariato') {
      return <><VolunteerPage /><Footer /></>;
    }

    if (currentHash === '#/admin/add-dog') {
      return <><AddDogPage /><Footer /></>;
    }

    if (currentHash === '#/contatti') {
      return <><ContactPage /><Footer /></>;
    }

    if (currentHash === '#/privacy') {
      return <><PrivacyPolicyPage /><Footer /></>;
    }

    if (currentHash.startsWith('#/adozione/')) {
      const dogId = currentHash.replace('#/adozione/', '');
      return <><AdoptionPage dogId={dogId} /><Footer /></>;
    }

    if (currentHash === '#/adozione') {
      return <><AdoptionPage /><Footer /></>;
    }

    if (currentHash.startsWith('#/dog/')) {
      const dogId = currentHash.replace('#/dog/', '');
      return <><DogStoryPage dogId={dogId} /><Footer /></>;
    }

    // Default Home Page
    return (
      <div className="App">
        <Navbar />
        <Hero />
        <DogsGrid />
        <Stories />
        <AdoptionSteps />
        <Donations />
        <Testimonials />
        <ContactForm />
        <Footer />
      </div>
    );
  };

  return (
    <>
      {renderContent()}
      <CookieBanner />
    </>
  );
}

export default App;
